<template>
	<div class="page">
		<div class="d-flex mx-md-auto pt-0 tasks-wrapper">
			<v-row class="my-0">
			<v-col cols="12" md="8" class="pt-0">
				<div v-if="loading">
					<v-skeleton-loader
						height="724"
						type="image, image, image, image"
					></v-skeleton-loader>
				</div>
				<v-card v-else flat outlined class="task-card">
					<v-btn
						@click="menuActive = !menuActive"
						icon
						class="d-block d-md-none hamburger"
					>
						<v-icon>mdi-menu</v-icon>
					</v-btn>
					<add-new-task
						v-if="
							$store.state.tasks.view.name !== 'completed' &&
							$store.state.tasks.view.name !== 'deleted' &&
							$store.state.tasks.view.name !== 'received' &&
							$store.state.tasks.view.name !== 'commissioned'
						"
					/>

					<div
						v-if="
							$store.state.tasks.view.name !== 'completed' &&
							$store.state.tasks.view.name !== 'deleted' &&
							$store.state.tasks.view.name !== 'received' &&
							$store.state.tasks.view.name !== 'commissioned'
						"
						class="mx-6 divider"
					/>

					<div v-else class="mb-10 d-block d-md-none"></div>
					<list-of-tasks />
				</v-card>
			</v-col>

			<v-col
				cols="8"
				sm="5"
				md="4"
				class="wall-right-column d-none d-md-block pt-0"
			>
				<div v-if="loading">
					<v-skeleton-loader
						type="image, image, image"
						height="400"
					></v-skeleton-loader>
					<v-skeleton-loader
						type="image, image, image"
						height="300"
						class="mt-6"
					></v-skeleton-loader>
				</div>
				<div v-else class="mh-custom sticky-top">
					<v-card flat outlined class="wall-card mb-6">
						<task-menu />
					</v-card>

					<v-card flat outlined class="wall-card d-md-block d-none mb-0">
						<stats />
					</v-card>
				</div>
			</v-col>

			<v-col
				cols="8"
				sm="5"
				md="4"
				class="wall-right-column d-block d-md-none pt-0"
			>
				<div class="mh-custom sticky-top">
					<Transition name="fade">
						<v-card
							v-if="menuActive"
							flat
							outlined
							class="wall-card mb-6"
						>
							<task-menu @closeMenu="menuActive = false" />
						</v-card>
					</Transition>
				</div>
			</v-col>
			</v-row>
		</div>
		<task-edit-dialog
				v-if="currentTask"
				:task="currentTask"
				:dialog="true"
				@closeDialog="taskClosed"
			/>
	</div>
</template>

<script>
import AddNewTask from "@/components/tasks/AddNewTask";
import ListOfTasks from "@/components/tasks/list/ListOfTasks";
import Stats from "@/components/tasks/Stats";
import TaskMenu from "@/components/tasks/TaskMenu";
import TaskEditDialog from "@/components/tasks/dialogs/TaskEditDialog";
import NotificationMarkMixin from "@/mixins/NotificationMarkMixin";

import { mapActions } from "vuex";
import axios from "axios";

export default {
	name: "Tasks",
	mixins: [NotificationMarkMixin],
	components: {
		AddNewTask,
		ListOfTasks,
		Stats,
		TaskMenu,
		TaskEditDialog
	},
	data() {
		return {
			menuActive: false,
			loading: true,
			currentTask: null
		};
	},
	computed: {
		notificationId() {
			return this.$route.query.ref == 'notification' && this.$route.query.notification_id;
		}
	},
	methods: {
		...mapActions("tasks", [
			"getTags",
			"getLists",
			"getTasks",
			"getDeletedTasks",
		]),
		taskClosed() {
			this.$router.push({name: 'Tasks'});
		},
		async getTask() {
			if(this.$route.params.id) {
				await axios.get('tasks/' + this.$route.params.id)
				.then(response => {
					this.currentTask = response.data.data;
				})
				.catch(error => {
					this.$snackbar.error({error:error})
					console.log("ERROR GETTING TASK", error)
				})
			}
		},
		async getTasksCount(filter) {
			let total;

			await axios
				.get("tasks", {
					params: {
						page: 1,
						filter_period: filter.filter_period || "",
						filter_status: filter.filter_status || "unfinished",
					},
				})
				.then((response) => {
					console.log(response);
					total = response.data.meta.total;
				})
				.catch((error) => {
					console.log("GET TASKS ERROR", error);
				});
			return total;
		},
	},
	async created() {
		await this.getTags();
		await this.getLists();
		await this.getTask();
		await this.handleNotification();

		await this.getDeletedTasks({ currentPage: 1 });
		this.$store.state.tasks.allTasksCount[0] = await this.getTasks({
			currentPage: 1,
		});

		["today", "tomorrow", "this_week"].forEach(async (filter, i) => {
			this.$store.state.tasks.allTasksCount[i + 1] =
				await this.getTasksCount({ filter_period: filter });
		});
		this.$store.state.tasks.allTasksCount = Object.assign(
			[],
			this.$store.state.tasks.allTasksCount
		);

		this.$store.state.tasks.completedTasksCount = await this.getTasksCount({
			filter_status: "finished",
		});

		this.loading = false;

		await axios
			.get("tasks", {
				params: {
					page: 1,
					filter_status: "unfinished",
					filter_assigned: 1,
				},
			})
			.then((response) => {
				this.$store.state.tasks.recievedTasks =
					response.data.meta.total;
			})
			.catch((error) => {
				console.log("GET TASKS ERROR", error);
			});

		await axios
			.get("tasks-commissioned", {
				params: {
					page: 1,
					filter_status: "unfinished",
				},
			})
			.then((response) => {
				this.$store.state.tasks.commisionedTasks =
					response.data.meta.total;
			})
			.catch((error) => {
				console.log("GET tasks-commissioned ERROR", error);
			});
	},
};
</script>

<style lang="scss" scoped>
.width-100 {
	width: 100%;
}

.divider {
	border-bottom: 1px solid #f2f2f3;
}

@media (max-width: 960px) {
	.tasks-wrapper {
		.wall-right-column {
			position: absolute;
			right: 0;
			transform: translateX(-16px);
		}
	}
}
.hamburger-wrapper {
	position: relative;
}
.hamburger {
	position: absolute;
	right: 16px;
	top: 19px;
	z-index: 10;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>
